const base_url_staging = "https://wildfire-watch-staging.herokuapp.com/api/";
const base_url_production = "https://wildfire-watch.herokuapp.com/api/";
const base_url_local = "http://localhost:5000/api/";

module.exports = { base_url_local, base_url_staging, base_url_production };
